import { DynamicModuleFactory } from 'vue-kit'
import RootStore from '../store'

export default DynamicModuleFactory(RootStore)
